export const INHERITANCE = {
  CA: ['IM'],
  S: ['EE'],
  U: ['EE', 'J'],
  G: ['U', 'C'],
  C: ['U'],
  V: ['EE', 'BO', 'W', 'R'],
  CH: ['EE'],
  IB: ['I'],
  WI: ['EE', 'CH'],
  B: ['IM', 'BO'],
  FD: ['BO'],
  ID: ['J'],
  SE: ['EE', 'A', 'J'],
  WSS: ['EE', 'A', 'J'],
  RES: ['BO', 'J', 'V'],
  RS: ['BO'],
  BSN: ['AN', 'EE'],
}
